import * as React from 'react';
import * as style from './style.css';
import { UIHeading2 } from '@cian/ui-kit';
import { IconFunctionalClock16, IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';

interface ISinglePhoneProps {
  availability: string;
  phone: string;
}

export const SinglePhone = ({ phone, availability }: ISinglePhoneProps): React.JSX.Element => {
  return (
    <div className={style['container']}>
      <UIHeading2>{phone}</UIHeading2>
      {availability && (
        <div className={style['info']}>
          <div className={style['icon']}>
            <IconFunctionalClock16 />
          </div>
          <span>{availability}</span>
        </div>
      )}
      <div className={style['info']}>
        <div className={style['icon']}>
          <IconCommunicationPhone16 />
        </div>
        <span>Номер только для звонков, сообщения не дойдут</span>
      </div>
    </div>
  );
};
